// actions/filterActions.js
export const SAVE_FILTER_STATE = 'SAVE_FILTER_STATE';

export const saveFilterState = (filterState) => {
    return ({
        type_FILTER_STATE,
        payload,
    })
};
